import React from 'react';
import './DoneScreen.css'; // Asegúrate de que el CSS esté en el lugar correcto
import playSVG from './Iconos/play.svg';
import { useHistory } from 'react-router-dom';
import perfil1SVG from './Iconos/user-1.svg'
import TapTatSVG from './Iconos/TapTat.svg';
import gif1 from './Imagenes/Gif/gif1.gif';
import vector1 from './Imagenes/Vector-1.png';

function StatusComponent() {

    const history = useHistory();
    const handlePreviousClick = () => {
        // Aquí cambias la ruta al segundo paso
        history.push('/ImageCreationChoice');
    };
    const handleNextClick = () => {
        // Aquí pones la lógica para ir al paso anterior
        history.push('/PerfilPage');
    };

    return (
        <div className="status-container">
            <div className="status-icons">
                <div className="icono-done">
                <img src={vector1} alt="Process" />
                </div>
                <div className="logos-done">
                <img src={gif1} alt="Profile" />
                <img src={TapTatSVG} alt="Check" />
                </div>
            </div>
            <div className="text-container3">
                <div className='heading'>¡Listo!</div>
                <div className='subtitle2'>Estoy procesando tu <br/> publicación</div>
                <div className='description'>Espera unos instantes...</div>
                <div className="status-actions">
                    <button className="manage-brand-btn3" onClick={handlePreviousClick}><img src={playSVG} alt="" />Crear otra vez</button>
                    <button className="manage-brand-btn3" onClick={handleNextClick}><img src={perfil1SVG} alt="" />Ir al Perfil</button>
                </div>
            </div>
        </div>
    );
}

export default StatusComponent;
